import { IResourceComponentsProps, useTranslate } from "@refinedev/core";
import { Create, useForm } from "@refinedev/antd";
import React, { useState } from 'react';
import { Flex, Form, Input, Switch } from "antd";
import FormEditor from "./FormEditor";
export const FormCreate: React.FC<IResourceComponentsProps> = () => {

    const _t = useTranslate();
    const { form, formProps, saveButtonProps, queryResult } = useForm();


    const setFormCode = (code: string) => {
        console.log("Form code", code);
        form.setFieldValue('schema', code);
    }

    return (
        <Create saveButtonProps={saveButtonProps}>
            <Form {...formProps} layout="vertical">
                <Flex gap={16}>
                    <Form.Item
                        label={_t("forms.fields.name")}
                        name="name"
                        className="w-96"
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={_t("forms.fields.isDefault")}
                        name="isDefault"
                        valuePropName="checked"
                        className="w-60"
                    >
                        <Switch />
                    </Form.Item>
                </Flex>
                <Form.Item
                    label={_t("forms.fields.schema")}
                    name="schema"
                    hidden
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>
            </Form>
            <FormEditor initForm={null} setForm={setFormCode} />
        </Create>
    );
}


